import Page from './Page';
import Component from 'vue-class-component';

import template from './Top.vue.html';
@Component({ template })
export default class Top extends Page {
    async proceed() {
        try {
            const r = await this.app.post('set-language', {
                language: this.app.getLang(),
            });
            if (!r.succeed) throw new Error(r.error);

            this.app.setPage(this.app.code ? 'Terminal' : 'Menu');
        } catch (err) {
            console.error(err);
            const msg = err instanceof Error ? err.message : String(err);
            alert(msg || 'Connection Error');
        }
    }
}
